import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const BadResponseState = ({ error, isMobileMode }) => (
  <div className={cx('bad-response-state', { 'app-selection-mobile-container': isMobileMode })}>
    <h2 className="bad-response-state-header text-16 text-uppercase text-red">
      Something went wrong
    </h2>

    <div className="bad-response-state-body">
      <div className="bad-response-state-image" />
    </div>

    <p className="bad-response-state-footer text-16 text-red text-center">{error}</p>
  </div>
);

BadResponseState.propTypes = {
  error: T.string,
  isMobileMode: T.string,
};

export default BadResponseState;
